import { doMutation } from "../../core-module/util/graphqlHelper";
import { onLogin } from "../../../plugins/vue-apollo";
import { deviceId, isAuthenticatedRole } from "../helpers/authHelper";

export const signIn = (emailOrCivilIdOrPassport, password) => {
  const mutation = require("../api/mutation/signIn.gql");
  const variables = {
    input: {
      emailOrCivilIdOrPassport,
      password,
      deviceId: deviceId(),
    },
  };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      if (isAuthenticatedRole(data?.signIn?.user?.role)) {
        onLogin(data.signIn);
        return { data: data.signIn };
      } else {
        return { error: "NOT_FOUND" };
      }
    } else if (error) return { error: JSON.stringify(error) };
  });
};
